import axios from "axios";

const BASE_URL = "https://playable.prod.kavinteam.in";



const api = {

    login: async (userid, password, additionalData) => {
        try {
          const requestData = {
            userid,
            password,
            ...additionalData,
          };
          const response = await axios.post(`${BASE_URL}/playablereactapp/web_login`, requestData, {
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
            },
          });
    
          return response.data;
        } catch (error) {
          console.error("Login error:", error.message);
          throw error;
        }
    },

    get_Reports:  async (requestData) => {
      try {
        const response = await axios.post(`${BASE_URL}/playablereactapp/playable_reg_users`, requestData, {
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching raw data:", error.message);
        throw error;
      }
  },



}
export default api;
